import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { mockTools } from './data/mockTools';

const useAuth = () => ({
  user: true,
  login: () => { },
  logout: () => { }
});


const CreatorProfile = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [creator, setCreator] = useState(null);

  useEffect(() => {
    if ((id === 'me' || (user && id === user.email)) && user) {
      const savedProfile = localStorage.getItem('creatorProfile');
      if (savedProfile) {
        try {
          const profileData = JSON.parse(savedProfile);
          // If no products, add some mock products for demo
          if (!profileData.tools || profileData.tools.length === 0) {
            profileData.tools = [
              {
                id: 'demo1',
                title: 'Content Calendar Template',
                description: 'A Notion template to plan and schedule your content.',
                author: profileData.name,
                authorId: profileData.id,
                category: 'Productivity',
                tags: ['Notion', 'Template', 'Content'],
                price: 19.99,
                imageUrl: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80',
                files: [],
                benefits: ['Plan ahead', 'Stay organized'],
                reviews: [],
                downloads: 120,
                rating: 4.7
              },
              {
                id: 'demo2',
                title: 'Startup Financial Model',
                description: 'A spreadsheet for projecting your startup finances.',
                author: profileData.name,
                authorId: profileData.id,
                category: 'Finance',
                tags: ['Finance', 'Spreadsheet', 'Startup'],
                price: 49.99,
                imageUrl: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=400&q=80',
                files: [],
                benefits: ['Easy projections', 'Investor ready'],
                reviews: [],
                downloads: 80,
                rating: 4.9
              },
              {
                id: 'demo3',
                title: 'Personal CRM',
                description: 'A tool to manage your contacts and relationships.',
                author: profileData.name,
                authorId: profileData.id,
                category: 'CRM',
                tags: ['CRM', 'Contacts', 'Productivity'],
                price: 29.99,
                imageUrl: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80',
                files: [],
                benefits: ['Never forget a follow-up'],
                reviews: [],
                downloads: 60,
                rating: 4.8
              }
            ];
          }
          setCreator(profileData);
        } catch (err) {
          console.error('Error parsing saved profile:', err);
        }
      } else {
        setCreator({
          id: user.email,
          name: user.email,
          bio: '',
          website: '',
          socialLinks: {},
          categories: [],
          imageUrl: user.user_metadata?.avatar_url || '',
          totalDownloads: 0,
          averageRating: 0,
          lastActivity: new Date().toISOString(),
          tools: [
            {
              id: 'demo1',
              title: 'Content Calendar Template',
              description: 'A Notion template to plan and schedule your content.',
              author: user.email,
              authorId: user.email,
              category: 'Productivity',
              tags: ['Notion', 'Template', 'Content'],
              price: 19.99,
              imageUrl: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80',
              files: [],
              benefits: ['Plan ahead', 'Stay organized'],
              reviews: [],
              downloads: 120,
              rating: 4.7
            },
            {
              id: 'demo2',
              title: 'Startup Financial Model',
              description: 'A spreadsheet for projecting your startup finances.',
              author: user.email,
              authorId: user.email,
              category: 'Finance',
              tags: ['Finance', 'Spreadsheet', 'Startup'],
              price: 49.99,
              imageUrl: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=400&q=80',
              files: [],
              benefits: ['Easy projections', 'Investor ready'],
              reviews: [],
              downloads: 80,
              rating: 4.9
            },
            {
              id: 'demo3',
              title: 'Personal CRM',
              description: 'A tool to manage your contacts and relationships.',
              author: user.email,
              authorId: user.email,
              category: 'CRM',
              tags: ['CRM', 'Contacts', 'Productivity'],
              price: 29.99,
              imageUrl: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80',
              files: [],
              benefits: ['Never forget a follow-up'],
              reviews: [],
              downloads: 60,
              rating: 4.8
            }
          ]
        });
      }
    } else if (id) {
      const creatorTools = mockTools.filter(tool => tool.authorId === id);
      if (creatorTools.length > 0) {
        const firstTool = creatorTools[0];
        setCreator({
          id: firstTool.authorId,
          name: firstTool.author,
          bio: `${firstTool.author} is a professional tool creator with expertise in ${firstTool.category.toLowerCase()}.`,
          website: 'https://example.com',
          socialLinks: {
            twitter: 'https://twitter.com/example',
            linkedin: 'https://linkedin.com/in/example',
            github: 'https://github.com/example'
          },
          categories: [firstTool.category],
          imageUrl: 'https://ui-avatars.com/api/?name=' + encodeURIComponent(firstTool.author) + '&background=007bff&color=fff',
          totalDownloads: creatorTools.reduce((sum, tool) => sum + (tool.downloads || 0), 0),
          averageRating: creatorTools.reduce((sum, tool) => sum + (tool.rating || 0), 0) / creatorTools.length,
          lastActivity: new Date().toISOString(),
          tools: creatorTools
        });
      }
    }
  }, [id, user]);

  if (!creator) return <div className="loading">Loading...</div>;

  // Mock stats for followers
  const followers = 974;
  const following = 444;

  return (
    <div className='creator-profile-container'>
      <div className="creator-profile" style={{ maxWidth: 700, margin: '0 auto', padding: '2rem 1rem' }}>
        {/* Top Section */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '2rem' }}>
          <div style={{ position: 'relative', marginBottom: '1rem' }}>
            <img
              src={creator.imageUrl || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(creator.name) + '&background=007bff&color=fff'}
              alt={creator.name}
              style={{ width: 120, height: 120, borderRadius: '50%', objectFit: 'cover', border: '4px solid #60a5fa', boxShadow: '0 2px 8px rgba(0,0,0,0.12)' }}
            />
          </div>
          <h2 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '0.25rem', textAlign: 'center' }}>{creator.name}</h2>
          {/* Stats Row */}
          <div style={{ display: 'flex', gap: '2.5rem', margin: '1rem 0', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{creator.tools.length}</div>
              <div style={{ color: 'var(--color-text-secondary)', fontSize: '0.95rem' }}>Products</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{creator.totalDownloads}</div>
              <div style={{ color: 'var(--color-text-secondary)', fontSize: '0.95rem' }}>Downloads</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{followers}</div>
              <div style={{ color: 'var(--color-text-secondary)', fontSize: '0.95rem' }}>Followers</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{following}</div>
              <div style={{ color: 'var(--color-text-secondary)', fontSize: '0.95rem' }}>Following</div>
            </div>
          </div>
          {/* Bio */}
          <div style={{ color: 'var(--color-text-secondary)', marginBottom: '0.5rem', textAlign: 'center', fontSize: '1.1rem', maxWidth: 500 }}>{creator.bio}</div>
          {/* Website/Socials */}
          {creator.website && (
            <div style={{ marginBottom: '0.5rem', textAlign: 'center' }}>
              <a href={creator.website} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary)', fontWeight: 500 }}>{creator.website}</a>
            </div>
          )}
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', marginBottom: '1rem' }}>
            {creator.socialLinks?.twitter && <a href={creator.socialLinks.twitter} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary)' }}>Twitter</a>}
            {creator.socialLinks?.linkedin && <a href={creator.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary)' }}>LinkedIn</a>}
            {creator.socialLinks?.github && <a href={creator.socialLinks.github} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-primary)' }}>GitHub</a>}
          </div>
          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
            <button style={{ background: 'var(--color-primary)', color: '#fff', border: 'none', borderRadius: 24, padding: '0.5rem 1.5rem', fontWeight: 600, fontSize: '1rem', cursor: 'pointer' }}>Edit Profile</button>
            <button style={{ background: 'var(--color-input)', color: 'var(--color-text-secondary)', border: 'none', borderRadius: 24, padding: '0.5rem 1.5rem', fontWeight: 600, fontSize: '1rem', cursor: 'pointer' }}>Settings</button>
          </div>
        </div>
        {/* Grid of Products */}
        <div className="creator-tools">
          <div className="tools-grid" style={{ marginTop: 0 }}>
            {creator.tools.map(tool => (
              <div key={tool.id} className="tool-card">
                {tool.imageUrl && <img src={tool.imageUrl} alt={tool.title} className="tool-image" />}
                <div className="tool-info">
                  <h3 className="tool-title">{tool.title}</h3>
                  <div className="tool-description">{tool.description}</div>
                  <div className="tool-author">By {tool.author}</div>
                  <div className="tool-tags">
                    {tool.tags.map(tag => (
                      <span key={tag} className="tool-tag">{tag}</span>
                    ))}
                  </div>
                  <div className="tool-bottom">
                    <span className="tool-price">${tool.price.toFixed(2)}</span>
                    <span className="product-label" style={{ color: 'var(--color-text-secondary)', fontSize: '0.85rem', background: 'var(--color-input)', borderRadius: '999px', padding: '0.25rem 0.75rem', marginLeft: '0.5rem' }}>Product</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CreatorProfile;